import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { http, formatApiError } from "@/lib/api";

export default function ResetPasswordPage() {
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const navigate = useNavigate();
    const [password, setPassword] = useState("");
    const [confirm, setConfirm] = useState("");
    const [done, setDone] = useState(false);
    const [error, setError] = useState("");
    const [submitting, setSubmitting] = useState(false);

    async function onSubmit(e) {
        e.preventDefault();
        setError("");
        if (password !== confirm) { setError("Passwords don't match."); return; }
        if (!token) { setError("Missing reset token. Use the link from your email."); return; }
        setSubmitting(true);
        try {
            await http.post("/auth/reset-password", { token, password });
            setDone(true);
            setTimeout(() => navigate("/login"), 2500);
        } catch (err) { setError(formatApiError(err)); }
        finally { setSubmitting(false); }
    }

    return (
        <div className="min-h-[80vh] flex items-center justify-center px-6 py-16">
            <div className="w-full max-w-md">
                <div className="label-eyebrow mb-4">/ Set a new password</div>
                <h1 className="font-serif text-4xl mb-8">Choose a <span className="gold-text italic">new password</span></h1>

                {done ? (
                    <div data-testid="reset-success" className="bg-slate-900/60 border border-gold/30 rounded-sm p-6">
                        <p className="text-slate-200">✓ Password updated. Redirecting to sign in…</p>
                    </div>
                ) : (
                    <form onSubmit={onSubmit} className="space-y-5" data-testid="reset-form">
                        <div>
                            <label className="text-xs uppercase tracking-widest text-slate-400">New password</label>
                            <input
                                data-testid="reset-password"
                                type="password" required minLength={6}
                                value={password} onChange={(e) => setPassword(e.target.value)}
                                className="mt-2 w-full bg-slate-900 border border-white/10 rounded-sm px-4 py-3 focus:outline-none focus:border-gold"
                            />
                        </div>
                        <div>
                            <label className="text-xs uppercase tracking-widest text-slate-400">Confirm password</label>
                            <input
                                data-testid="reset-confirm"
                                type="password" required minLength={6}
                                value={confirm} onChange={(e) => setConfirm(e.target.value)}
                                className="mt-2 w-full bg-slate-900 border border-white/10 rounded-sm px-4 py-3 focus:outline-none focus:border-gold"
                            />
                        </div>
                        {error && <div data-testid="reset-error" className="text-sm text-red-400">{error}</div>}
                        <button data-testid="reset-submit" disabled={submitting} className="btn-gold w-full disabled:opacity-50">
                            {submitting ? "Updating…" : "Update password"}
                        </button>
                        <div className="text-sm text-slate-400 text-center">
                            <Link to="/login" className="gold-text hover:underline">Back to sign in</Link>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
}
